<sub-header [includeContextHelp]="true" [isModal]="true" [windowHash]=windowHash>
</sub-header>
<div class="container-fluid " aria-hidden="true" cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
  <p-scrollPanel [style]="{width: '100%', height: '80vh'}" styleClass="custombar1">
    <div class="container-fluid m-b-lg ">
      <div class="row" *ngIf="model.validationErrors">
        <div class="col-12 p-0">
          <div class="col-12 alert alert-warning">
            <i class="fas fa-1-5x fa-info-circle m-r-md" aria-hidden="true"></i>
            <span [innerHTML]="model.validationErrors">
            </span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <strong class="text-danger col-12">{{ 'TaskActions.description' | translate }}</strong>
          <div class="form-group text-center">
            <div *ngIf="model.workActions?.parameters?.length > 0">
              <div class="form-group row" *ngFor="let parameter of model.workActions.parameters">
                <label class="col-sm-12 col-form-label col-form-label-sm"
                  [attr.for]="parameter.name">{{parameter.name}}</label>
                <div class="col-sm-12">
                  <input id="{{parameter.name}}" type="text" class="form-control"
                    placeholder="{{parameter.description}}" [ngModel]='getUpdatedWorkProperty(parameter.jsonPath)'
                    (ngModelChange)="updateProperty(parameter.jsonPath, $event)" autocomplete="off"
                    [maxlength]="parameter.maxLength" [minlength]="parameter.minLength " />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <ul>
            <li class="text-left" *ngFor="let action of model.task.availableActions?.actions"
              [innerHTML]="action.description">
            </li>
            <li class="text-left" *ngFor="let action of model.workActions?.actions" [innerHTML]="action.description">
            </li>
            <li class="text-left"> {{'TaskActions.close' | translate }}</li>
          </ul>
        </div>
        <div class="col-12 d-flex justify-content-center m-b-md">
          <div class="btn-group-xs">
            <ng-template ngFor let-action [ngForOf]="getSecondaryActions()">
              <button class="m-l-xs btn" [ngClass]="classAction(action)" (click)="patch(action)"
                ng-mousedown="$event.preventDefault();" appNoDblClick>
                <i [ngClass]="classActionIcon(action)"></i> {{action.name}}</button>
            </ng-template>
            <ng-template ngFor let-action [ngForOf]="getPrimaryActions()" ng-mousedown="$event.preventDefault();">
              <button class="m-l-xs btn" [ngClass]="classAction(action)" (click)="patch(action)" appNoDblClick>
                <i [ngClass]="classActionIcon(action)"></i> {{action.name}}</button>
            </ng-template>
            <button class="m-l-xs btn btn-outline-secondary" (click)="closeWindow()"
              ng-mousedown="$event.preventDefault();" appNoDblClick>
              <i class="fas fa-close"></i> {{'General.close' | translate }}</button>
          </div>
        </div>
      </div>
    </div>
  </p-scrollPanel>
</div>